module.exports = __webpack_public_path__ + "img/highShotText2.b6ecdfb0.png";